import { Callout } from "@octopusdeploy/design-system-components";
import { ProcessType } from "@octopusdeploy/octopus-server-client";
import { isString } from "lodash";
import type { ReactNode } from "react";
interface StepUnsupportedInProcessTemplateCalloutProps {
    actionWarnings: (string | ReactNode)[];
    processType: ProcessType;
}
export default function StepUnsupportedInProcessTemplateCallout({ actionWarnings, processType }: StepUnsupportedInProcessTemplateCalloutProps) {
    if (processType !== ProcessType.ProcessTemplate || actionWarnings.length === 0) {
        return null;
    }
    if (actionWarnings.filter((w) => isString(w)).some((w) => w.includes("step is not supported"))) {
        return (<Callout type={"warning"} title="This step is not supported in Process Templates">
                You’ll need to remove it before the template can be published.
            </Callout>);
    }
    return null;
}
